import React, { Component } from "react";

export default class Social extends Component {
  render() {
    return <div>Social</div>;
  }
}
